import script from "./BottomCont.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomCont.vue?vue&type=script&setup=true&lang=js"

import "./BottomCont.vue?vue&type=style&index=0&id=1a661dc5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a661dc5"]])

export default __exports__